import React from 'react';

import PageContainer from 'components/common/PageContainer';
import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import BigComponent from './components/BigComponent';
import SmallComponent from './components/SmallComponent';

function DocsPage() {
  return (
    <PageContainer>
      <AppPageHeader title="Documentation" />

      <PageRow>
        <BigComponent />

        <div>
          <SmallComponent title="Support"/>
          <SmallComponent title="Billing"/>
        </div>
      </PageRow>
    </PageContainer>
  );
}

export default DocsPage;
